import React from 'react';
import { svgToIcon } from '../../utils/svg';
import Tool, {
  simpleToolButton,
  type IToolActionInput,
  type IToolAvailableInput,
  type ToolButtonComponent,
} from '../Tool';
import ToolWireframe from './ToolWireframe';
import wireframeAddItemVertical from '../../assets/icons/wireframeAddItemVertical.svg';
import wireframeAddItemHorizontal from '../../assets/icons/wireframeAddItemHorizontal.svg';
import { ApplicationView } from '@aha-app/mvc';
import ToolButton from '../../toolbars/ToolButton';
import { isWireframe } from '../../objects/guards';
import { WIREFRAME_SELECTION_ERROR_MESSAGE } from '../../utils/tools';
import type Wireframe from '../../objects/Wireframe';

const AddItemButton: ToolButtonComponent = ApplicationView(
  ({ controller, selection, tool }) => {
    if (!isWireframe(selection)) {
      console.error(WIREFRAME_SELECTION_ERROR_MESSAGE);
      return null;
    }

    const icon =
      selection.firstObject().layout === 'column'
        ? wireframeAddItemVertical
        : wireframeAddItemHorizontal;

    return (
      <ToolButton
        onClick={() => {
          ToolWireframeAddItem.action({ selection, controller });
        }}
        tool={tool}
      >
        {svgToIcon(icon)}
      </ToolButton>
    );
  }
);

class ToolWireframeAddItem extends ToolWireframe {
  static toolName = 'Add item';

  static action({ selection, controller }: IToolActionInput): void {
    (selection as Wireframe).wireframe.addItem();
    Tool.toolActionComplete({ controller });
  }

  static available({ selection }: IToolAvailableInput) {
    return selection?.type === 'wireframe';
  }

  static buttonComponent() {
    return AddItemButton;
  }
}

// The plus and minus versions of this tool only exist in the toolbar (as opposed
// to per item)
class ToolWireframeAddItemPlus extends ToolWireframe {
  static toolName = 'Add item';

  static action({ selection, controller }: IToolActionInput): void {
    (selection as Wireframe).wireframe.addItem();
    Tool.toolActionComplete({ controller });
  }

  static available({ selection }: IToolAvailableInput) {
    return selection?.type === 'wireframe';
  }

  static buttonComponent() {
    return simpleToolButton(ToolWireframeAddItemPlus, 'fa-regular fa-plus');
  }
}

class ToolWireframeAddItemMinus extends ToolWireframe {
  static toolName = 'Remove item';

  static action({ selection, controller }: IToolActionInput): void {
    (selection as Wireframe).wireframe.removeLastItem();
    Tool.toolActionComplete({ controller });
  }

  static available({ selection }: IToolAvailableInput) {
    return selection?.type === 'wireframe';
  }

  static enabled({ selection }: IToolAvailableInput) {
    if (!selection) return false;
    if (!isWireframe(selection)) return false;
    return selection.wireframe.toolRemoveItemEnabled();
  }

  static buttonComponent() {
    return simpleToolButton(ToolWireframeAddItemMinus, 'fa-regular fa-minus');
  }
}

export {
  ToolWireframeAddItem,
  ToolWireframeAddItemPlus,
  ToolWireframeAddItemMinus,
};
